import Flex from "@/components-library/layout/flex";
import classes from "./menu-item.module.scss";

import { Link } from "react-router-dom";
import Label from "@/components-library/widgets/label";
import ExpandableGroup from "@/components-library/layout/expandable-group";
import ExpandableContainer from "@/components-library/layout/expandable-container";

function MenuItem({
  id,
  menuItemTitle,
  link,
  subMenuOptions,
  onSelectManeuItem,
  isSubMenuOpen,
}) {
  return (
    <Flex direction="row" align="center" className={classes.containerMenuItem}>
      <ExpandableContainer
        header={
          <Flex
            direction="row"
            align="center"
            justify="space-between"
            className={classes.headerMenuItem}
          >
            <Label
              align="start"
              size="xl"
              color="navbar"
              onClick={onSelectManeuItem(
                subMenuOptions?.length ? id : undefined
              )}
            >
              {link && (
                <Link to={link} className={classes.link_nowrap}>
                  {menuItemTitle}
                </Link>
              )}
              {!link && (
                <span className={classes.link_nowrap}>{menuItemTitle}</span>
              )}
            </Label>
            {!!subMenuOptions?.length && (
              <span
                className={classes.chevron}
                aria-hidden="true"
                title="Apri sottomenu"
              />
            )}
          </Flex>
        }
        isOpen={isSubMenuOpen}
        className={classes.header}
      >
        {!!subMenuOptions?.length && (
          <ExpandableGroup singleOpen={isSubMenuOpen}>
            {subMenuOptions.map(({ title, link }, index) => (
              <Label
                key={`${title}-${index}`}
                align="start"
                size="lg"
                color="navbar"
                onClick={onSelectManeuItem(undefined)}
                className={classes.subMenuText}
              >
                <Link to={link} className={classes.link_nowrap}>
                  {title}
                </Link>
              </Label>
            ))}
          </ExpandableGroup>
        )}
      </ExpandableContainer>
    </Flex>
  );
}

export default MenuItem;
